import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden bg-gradient-to-br from-cream via-white to-beige" data-id="element-63">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-64" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10" data-id="element-65">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-66">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-67">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="inline-block px-4 py-1.5 rounded-full bg-sage/10 text-sage-dark font-semibold text-sm mb-6 border border-sage/20" data-id="element-68">
              $9.999 — Acceso inmediato
            </motion.div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy leading-tight mb-6" data-id="element-69">
              ¿Y si pudieras rediseñar tu realidad en solo{' '}
              <span className="text-sage italic" data-id="element-70">30 días</span>? 🕯️✨
            </h1>

            <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-71">
              Despierta el poder del "Yo Soy" y manifiesta la paz, la abundancia
              y la claridad que te pertenecen por derecho divino.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-72">
              <Button variant="primary" size="lg" withArrow pulse onClick={() => document.getElementById('cta-button')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })} data-id="element-73">
                QUIERO MI EBOOK
              </Button>
              <p className="text-sm text-gray-500 mt-2 sm:mt-0" data-id="element-74">
                Empieza tu despertar hoy
              </p>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative flex justify-center" data-id="element-75">
            <motion.div animate={{
            y: [-10, 10, -10]
          }} transition={{
            repeat: Infinity,
            duration: 6,
            ease: 'easeInOut'
          }} className="relative z-10" data-id="element-76">
              <img src="https://cdn.magicpatterns.com/uploads/dmhVPptKVVseoHeTGRvevn/portada_30_dias_para_despertar_-_ok.png" alt="Ebook 30 Días para Despertar tu Ser" className="w-full max-w-md md:max-w-lg drop-shadow-2xl rounded-lg transform rotate-[-2deg] hover:rotate-0 transition-transform duration-500" data-id="element-77" />
            </motion.div>

            {/* Decorative Elements behind image */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-sage/10 rounded-full blur-3xl -z-10" data-id="element-78" />
          </motion.div>
        </div>
      </div>
    </section>;
}